export default class InvalidDomainError extends Error {
  constructor() {
    super('The domain used is unauthorized')

    this.name = 'InvalidDomainError'
  }
}
